import React,{ Component } from 'react';
import TinyMCEFileManager from './TinyMCEFileManager';
import { Editor } from '@tinymce/tinymce-react';

const INITIAL_STATE = {
    
    showManager:false,
    tinyMCECallBack:"",
    tinyMCEFileType:""

}


class TinyMCEEditor extends Component {

    constructor(props){

        super(props);
        this.state = INITIAL_STATE;
        this.hideManager = this.hideManager.bind(this);
        
    }

    hideManager(){
        this.setState({
            showManager:false
        })
    }

    render(){

        const {showManager,tinyMCECallBack,tinyMCEFileType} = this.state;

        return(
            <div>

            <Editor
                name="description"
                apiKey = '9z3phhnyq7jkeeqztql1euovfotvpd2gdduygtdpk14wu4ij'
                value={this.props.initialValue}
                init={{
                    plugins: 'link image code paste emoticons media lists',
                    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | formatselect | numlist bullist checklist | link | blockquote | image | media | emoticons | code',
                    paste_as_text: true,
                    language_url : '/langs/cs.js',
                    language: "cs",
                    height:1000,
                    image_advtab: true,
                    file_picker_types: 'file image',
                    file_picker_callback: (callback, value, meta) => {
                        
                        if(meta.filetype == "image" || meta.filetype == "file"){
                            this.setState({showManager:true,tinyMCECallBack:callback, tinyMCEFileType:meta.filetype}) 
                        }

                    }
                        
                }}
                onEditorChange={(content) => this.props.onChange(content,"text")}
            />
            {showManager && 
                <TinyMCEFileManager callback={this.hideManager} tinyMCECallBack = {tinyMCECallBack} tinyMCEFileType={tinyMCEFileType} />
            }
            </div>
        )

    }

}

export default TinyMCEEditor;  